import React from 'react';
import { Navigate } from 'react-router';

import { OrderStep } from 'src/state/order/types';
import { hasSeveralUnitsToUpgrade, isEligibleToUpgrade } from 'src/utils/equipment-utils';
import { useProductsResponseQueryStateOrThrow } from 'src/hooks/use-products-query';
import { NavigationService } from 'src/services/navigation-service';
import { withOrderStep } from 'src/hocs/with-order-step';

import { UpgradeOnePage } from './upgrade-one-page';
import { UpgradeSeveralPage } from './upgrade-several-page';

export const UpgradePageComponent = () => {
  const { upgradeDecoder } = useProductsResponseQueryStateOrThrow();

  if (!isEligibleToUpgrade(upgradeDecoder)) {
    return <Navigate to={NavigationService.PRODUCT_PURCHASE} replace={true} />;
  }

  return hasSeveralUnitsToUpgrade(upgradeDecoder.upgradableUnits) ? <UpgradeSeveralPage /> : <UpgradeOnePage />;
};

export const UpgradePage = withOrderStep(OrderStep.UPGRADE_DECODER)(UpgradePageComponent);
